import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import uniqid from 'uniqid';

// Hooks
import useNotifications from '@/utils/hooks/swr/useNotifications';

// Types
import type { filtersStateType } from '@/components/pages/notifications/types';

// Actions
import ActionBar from '@/components/pages/notifications/ActionBar';
import DataNotificationsErrorFallback from '@/components/pages/notifications/DataNotificationsErrorFallback';
import HeaderNotifications from '@/components/pages/notifications/HeaderNotifications';
import ListNotifications from '@/components/pages/notifications/ListNotifications';

const Content = () => {
    const [filters, setFilters] = useState<filtersStateType>({
        unread: false,
        categories: [],
        cacheId: uniqid() // use to reload the cache each time a filter is changed
    });

    const {
        dataNotifications,
        total_unread,
        total,
        notificationsError,
        isLoadMore,
        // Loaders
        isLoadingMore,
        isLoadingInitialData,
        // Functions
        mutateNotifications,
        loadMoreNotifications
    } = useNotifications(filters);

    return (
        <>
            <HeaderNotifications />
            <div className="flex flex-1 flex-col md:mt-5">
                <ActionBar
                    filters={filters}
                    setFilters={setFilters}
                    total_unread={total_unread}
                    total={total}
                    mutateNotifications={mutateNotifications}
                />
                <ErrorBoundary
                    FallbackComponent={DataNotificationsErrorFallback}
                    onReset={() => mutateNotifications(null)}>
                    <ListNotifications
                        dataNotifications={dataNotifications}
                        notificationsError={notificationsError}
                        isLoadMore={isLoadMore}
                        isLoadingMore={isLoadingMore}
                        isLoadingInitialData={isLoadingInitialData}
                        mutateNotifications={mutateNotifications}
                        loadMoreNotifications={loadMoreNotifications}
                    />
                </ErrorBoundary>
            </div>
        </>
    );
};

export default Content;
